// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".marquee-content[data-v-0bf40479]{animation:marquee-0bf40479 calc(0.3s * var(--num-chars)) linear infinite}@keyframes marquee-0bf40479{0%{transform:translateX(0%)}100%{transform:translateX(-100%)}}.scrolling[data-v-0bf40479]{display:flex;flex-direction:row;position:relative;overflow:hidden}.scrolling__row[data-v-0bf40479]{padding-right:var(--space-between-marquee);text-decoration:none;display:inline-block;white-space:nowrap}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
